import dayjs, { Dayjs } from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { currentTimeFormat } from "us.common/constants";
dayjs.extend(isSameOrAfter);

/**
 * @function
 * @description disabled hours
 * @param {Dayjs} startTime start time
 * @returns {Array<number>} array of disabled hours
 */
export const disabledHours = (startTime: Dayjs): Array<number> => {
    const hours: Array<number> = [];
    try {
        const currentHour: number = getSelectedHour(startTime);
        for (let i = 0; i < currentHour; i++) {
            hours.push(i);
        }
        return hours;
    } catch (error) {
        return hours;
    }
};

/**
 * @function
 * @description disabled minutes
 * @param {number} hour current hour
 * @param {number} selectedHour hour value of start time
 * @param {string} startTimeValue start time value
 * @returns {Array<number>} array of disabled minutes
 */
export const disabledMinutes = (
    hour: number,
    selectedHour: number,
    startTimeValue: string
): Array<number> => {
    const minutes: Array<number> = [];
    try {
        if (selectedHour === hour) {
            const currentMinutes: number = dayjs(
                startTimeValue,
                currentTimeFormat
            ).minute();

            for (let i = 0; i <= currentMinutes; i++) {
                minutes.push(i);
            }
        }
        return minutes;
    } catch (error) {
        return minutes;
    }
};

/**
 * @function
 * @description get hour value of provide time
 * @param { Dayjs} time 
 * @returns hour
 */
export const getSelectedHour = (time: Dayjs): number => {
    try {
        return dayjs(time, currentTimeFormat).hour();
    } catch (error) {
        return 0;
    }
};

/**
 * @function
 * @description compare start time and end time
 * @param {Dayjs} time value of start time field
 * @param {string} endTimeValue end time value
 * @returns {boolean}
 */
export const isStartTimeGreaterThanEndTime = (
    time: Dayjs,
    endTimeValue: string
): boolean => {
    try {
        return dayjs(time, currentTimeFormat).isSameOrAfter(
            dayjs(endTimeValue, currentTimeFormat)
        );
    } catch (error) {
        return false;
    }
};
